import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AdminFormFieldDropdown, AdminFormFieldSubmit, TSelectboxOption } from '../../../components/admin/formFields';
import svgIcons from '../../../assets/svg/svgIcons';
import { downloadTemplate } from '../../../api/network/bulkUploadApiServices';
import { UPLOAD_TYPE, UPLOAD_TYPE_OBJ } from './constants';
import { toast } from 'react-toastify';
import { ACL_NAMES, useACL } from '../../../hooks/acl';
import { useLoggedInUserData } from '../../../utils/user';
import { ROLE_ACCESS_LEVELS } from '../../admin-details/role/constants';

const ImportScreen: React.FC = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'admins.import_export' });
  const { t: tExport } = useTranslation('translation', { keyPrefix: 'admins.import_export.export' });
  const [selectedCategory, setSelectedCategory] = useState<TSelectboxOption | null>();

  const { getUserACLAccessLevel } = useACL();
  const thisOrgZipTieAllowed = useLoggedInUserData("serializedziptieallowed");

  const handleDownloadTemplate = () => {
    if (!selectedCategory) return;
    // Logic to download template for the selected category
    downloadTemplate({ type: parseInt(selectedCategory?.value) }, selectedCategory?.label ?? "Data");
  };

  const handleExportData = () => {
    if (!selectedCategory) return;
    // Logic to export data for the selected category
    downloadTemplate({ type: parseInt(selectedCategory?.value), with_data: 1 }, selectedCategory?.label ?? "Data",
      () => { },
      () => {
        toast.error(tExport("download_failed"));
      });
  };

  const handleCategoryChange = (option: TSelectboxOption | null) => {
    if (option) setSelectedCategory(option);
  };

  const includeSerializedZipTie = thisOrgZipTieAllowed === "1" && getUserACLAccessLevel(ACL_NAMES.ACL_ZIPTIE_CONFIG) >= ROLE_ACCESS_LEVELS.READ
  const options = (includeSerializedZipTie
    ? UPLOAD_TYPE_OBJ
    : UPLOAD_TYPE_OBJ.filter((item) => item.value !== 8)
  ).map((item) => ({
    label: item.label,
    value: item.value.toString(),
  }));

  return (
    <div>
      <p className="text-lg font-bold leading-6">{tExport("heading")}</p>
      <AdminFormFieldDropdown
        id="select_admin"
        label={t('selection_heading')}
        name={t('selection_heading')}
        placeholder={t('selection_placeholder')}
        value={selectedCategory ? selectedCategory?.value : undefined}
        onChange={handleCategoryChange}
        customWrapperClass="my-4"
        options={options}
      />
      <div className="flex row:between py-4">
        <div className="flex-auto" />
        <>
          <AdminFormFieldSubmit type="button"
            variant="primary-like"
            label={<span className="flex justify-center whitespace-nowrap">
              {tExport("template")}
              <img
                className="ml-2"
                src={svgIcons.Download}
                alt={tExport("template")}
              />
            </span>}
            onClick={handleDownloadTemplate}
            disabled={!selectedCategory}
          />
          <AdminFormFieldSubmit type="button"
            variant="primary-like"
            label={<span className="flex justify-center whitespace-nowrap">
              {tExport("export")}
              <img
                className="ml-2 grayscale"
                src={svgIcons.Upload}
                alt={tExport("export")}
              />
            </span>}
            onClick={handleExportData}
            customWrapperClass="mx-2"
            disabled={!selectedCategory}
          />
        </>
      </div>
    </div>
  );
};

export default ImportScreen;